import axios, { CancelToken } from 'axios';

import { QUALITY_MONITOR } from 'RestAPIs/endpoints';

type Day = {
  date: string | Date;
  totalNumberOfActions: number;
};

export type Entry = {
  costCenterId: number;
  costCenterName: string;
  days: Day[];
};

type Options = {
  params: {
    costCenterIds: string;
    startDate: string;
    endDate: string;
  };
  cancelToken: CancelToken;
};

export const getData = (options: Options) =>
  axios.get<Entry[]>(QUALITY_MONITOR, { ...options });
